// extracted by mini-css-extract-plugin
export var deleteIcon = "_o1-5";
export var deleteOption = "_o1-3";
export var divider = "_o1-2";
export var downloadIcon = "_o1-4";
export var drawer = "_o1-0";
export var drawerFooter = "_o1-6";
export var drawerOpen = "_o1-1";
export var highlighted = "_o1-7";
export var lighterHighlight = "_o1-8";